/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Notitietype_Sociaalemotioneelthemaresultaat6Inputs */

const nl_enums_notitietype_sociaalemotioneelthemaresultaat6 = /** @type {(inputs: Enums_Notitietype_Sociaalemotioneelthemaresultaat6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociaal-emotioneel thema resultaat`)
};

/**

* @param {Enums_Notitietype_Sociaalemotioneelthemaresultaat6Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_notitietype_sociaalemotioneelthemaresultaat6 = /** @type {((inputs?: Enums_Notitietype_Sociaalemotioneelthemaresultaat6Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Notitietype_Sociaalemotioneelthemaresultaat6Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_notitietype_sociaalemotioneelthemaresultaat6(inputs)
});
export { enums_notitietype_sociaalemotioneelthemaresultaat6 as "enums.NotitieType.SociaalEmotioneelThemaResultaat" }